export type ExecutiveSummaryGoals = {
  yearToDateRevenue: number
  monthToDateRevenue: number
  revenuePerFte: number
  conversionRatePct: number
  profitMarginPct: number
  npsScore: number
}

export interface ExecutiveSummaryData {
  revenuePerFte: number
  conversionRatePct: number
  profitMarginPct: number
  /** FTE count used for revenue per FTE */
  fteCount: number
  goals: ExecutiveSummaryGoals
}

export const DEFAULT_EXECUTIVE_SUMMARY_GOALS: ExecutiveSummaryGoals = {
  yearToDateRevenue: 2760000,
  monthToDateRevenue: 276000,
  revenuePerFte: 276000,
  conversionRatePct: 70,
  profitMarginPct: 20,
  npsScore: 72,
}

/** Projects with start date on or after this day are included in executive summary profit margin. */
export const EXECUTIVE_SUMMARY_PROFIT_MARGIN_START_DATE = '2026-05-01'

export const EXECUTIVE_SUMMARY: ExecutiveSummaryData = {
  revenuePerFte: 0,
  conversionRatePct: 0,
  profitMarginPct: 0,
  fteCount: 0,
  goals: DEFAULT_EXECUTIVE_SUMMARY_GOALS,
}
